module.exports = __webpack_public_path__ + "images/index/img01-1.1606631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/kua/img01-1.jpg
// module id = RBT4
// module chunks = 21